import { apiRequest } from "@/services/api-client";
import { OpenPackInput, OpenPackOutput, WebAppRoutes } from "types/web-app";

export const openPack = (input: OpenPackInput) =>
  apiRequest<OpenPackOutput>("/" + WebAppRoutes.OPEN_PACK, {
    method: "POST",
    body: JSON.stringify(input),
  });
